import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';

export const Paragraph = styled.p`
  margin-top: ${({ theme }) => theme.spacing.three_2};

  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.regular};
`;

export const LoginLink = styled(Link)<{ color?: string }>`
  color: ${({ theme, color }) => (color ? color : theme.colors.primary)};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
`;

export const ErrorMessage = styled.p`
  position: absolute;
  top: ${({ theme }) => theme.spacing.zero_2};

  color: ${({ theme }) => theme.colors.negative_dark};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
`;

export const RegistrationHeader = styled.h3<{ mb?: boolean }>`
  margin-bottom: ${({ theme, mb }) => (mb ? theme.spacing.zero_2 : theme.spacing.two_2)};

  color: ${({ theme }) => theme.colors.black_100};
  font-size: ${({ theme }) => theme.fontSize.xl};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  text-align: center;
`;

export const ButtonSpacing = styled.div<{ marginTop?: string }>`
  margin-top: ${({ theme, marginTop }) => (marginTop ? marginTop : theme.spacing.three)};
`;
